module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/3/5-d2f9e097c794c7c32ee2b6de5c908156.jpg";